module.exports = __webpack_public_path__ + "media/country_flags/cy-e463e37a.png";